const formatArgumentKey = (key, { isArray, parentKey } = {}) => {
  if (!key) {
    return '';
  }
  let formattedKey = key.endsWith('[]') ? key.slice(0, -2) : key;
  if (parentKey) {
    formattedKey = `${parentKey}.${formattedKey}`;
  }
  if (isArray) {
    formattedKey = `${formattedKey}[]`;
  }
  return formattedKey;
};

export default formatArgumentKey;
